// @view/panels/workspace/document-selection/DocumentListSection.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { DocumentMetadata } from "@ps-bridge/models/core/dataContracts";
import type { DocumentListSectionPhase } from "@ps-bridge/models/documents/documentListSectionPhase";
import DocumentListSectionView from "@view/workspace/document-selection/DocumentListSection.view";

type DocumentListSectionPanelProps = {
  phase: DocumentListSectionPhase;
  title: string;
  documents: DocumentMetadata[];
  renderDocumentItem: (doc: DocumentMetadata) => React.ReactElement;
  gridClassName: string;
};

const DocumentListSectionPanel: React.FC<DocumentListSectionPanelProps> = ({
  phase,
  title,
  documents,
  renderDocumentItem,
  gridClassName,
}) => {
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<DocumentListSectionPhase, DocumentListSectionPhase>;

  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: (
      <DocumentListSectionView
        title={title}
        documents={documents}
        renderDocumentItem={renderDocumentItem}
        gridClassName={gridClassName}
      />
    ),
  } as const satisfies Record<DocumentListSectionPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default DocumentListSectionPanel;
